import { IonItemOption, IonItemOptions } from "@ionic/react";
import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import styles from "@components/SlidingItemOptions.module.css";
import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";
import { Colors } from "@utils/colorUtils";
import { IconName } from "@utils/iconUtils";

type Props = ComponentProps<typeof IonItemOptions> & {
  options: {
    color: Colors;
    icon: IconName;
    onClick: () => void;
    textKey: string;
  }[];
};

const SlidingItemOptions = ({ children, options, ...props }: Props) => (
  <IonItemOptions {...props}>
    {options.map(option => (
      <IonItemOption
        className={`${styles.option} transform-text-none ${props.side === "end" ? styles.spacingStart : styles.spacingEnd}`}
        color={option.color}
        key={option.textKey}
        onClick={option.onClick}
      >
        <Icon color="white" icon={option.icon} size="small" />
        <BodyCopy bold color="white">
          <FormattedMessage id={option.textKey} />
        </BodyCopy>
      </IonItemOption>
    ))}
  </IonItemOptions>
);

export default SlidingItemOptions;
